import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AbcCoreAuthenticationModule } from '@barthauer/abc/core/authentication';
import { AbcUiComponentsModule } from '@barthauer/abc/ui-components';
import { LoginComponent } from './login/login.component';
import { DxTemplateModule, DxGalleryModule } from 'devextreme-angular';
import { ProfileSelectionComponent } from './profile-selection/profile-selection.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        MatToolbarModule,
        MatButtonModule,
        // MatAutocompleteModule,
        MatIconModule,
        MatInputModule,
        AbcCoreAuthenticationModule,
        DxTemplateModule,
        DxGalleryModule,
        AbcUiComponentsModule,
        FlexLayoutModule
    ],
    declarations: [LoginComponent, ProfileSelectionComponent],
    exports: [
        LoginComponent,
        MatToolbarModule,
        MatButtonModule,
        // MatAutocompleteModule,
        MatIconModule,
        MatInputModule,
        ProfileSelectionComponent,
        DxTemplateModule,
        DxGalleryModule
    ],
    providers: []
})
export class AptisCoreAuthenticationModule {}
